<template>
  <div>
    <h1>Users</h1>

    <div v-if="isTableLoading" class="text-center pt-3">
      <b-spinner label="Loading..." />
    </div>

    <template v-else>

      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <b-button variant="primary" class="float-right" v-b-modal.manage-modal @click="openAddModal">
            <span> Add user </span>
          </b-button>
        </b-form-group>
      </div>

      <!-- search input -->
      <!--<div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>
      </div>-->

      <vue-good-table
        :columns="columns"
        :rows="users"
        :search-options="{
          enabled: true,
          //externalQuery: searchTerm
          }"
        :pagination-options="{
          enabled: true,
          perPage:pageLength
        }"
      >
        <template #table-row="props">
          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'" class="action-link-group">
              <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                          right
                  >
                      <template v-slot:button-content>
                        <feather-icon
                                icon="MoreVerticalIcon"
                                size="16"
                                class="text-body align-middle"
                        />
                      </template>
                      <b-dropdown-item v-b-modal.manage-modal @click="openEditModal(props.row)">
                          <feather-icon icon="Edit2Icon" class="mr-50" />
                          <span>Edit</span>
                      </b-dropdown-item>

                      <b-dropdown-item @click="deleteItem(props.row.id)">
                          <feather-icon icon="TrashIcon" class="mr-50" />
                          <span>Delete</span>
                      </b-dropdown-item>
                  </b-dropdown>
          </span>
            <span v-else-if="props.column.field === 'inactive'">
                {{props.row.inactive == 0 ? 'Active' : 'Inactive'}}
            </span>
            <DatatableCellValue
              v-else
              :field="props.column.field"
              :value="props.formattedRow[props.column.field]"
            />

        </template>

        <!-- pagination -->
        <template #pagination-bottom="props">
          <TablePagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              @input="(value)=>props.pageChanged({currentPage:value})"
              @per-page-change="(n) => { pageLength = n; props.perPageChanged({ currentPerPage: n }) }"
            />
        </template>
      </vue-good-table>

      <b-modal
        id="manage-modal"
        :title="edited.id > 0 ? 'Edit user' : 'Add user'"
      >

        <b-form>

          <b-form-group label="Name:" label-for="input-name">
              <b-form-input id="name" v-model="edited.name" placeholder="User Name" required />
              <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
          </b-form-group>

          <b-form-group label="Email:" label-for="input-email">

              <b-form-input id="email" v-model="edited.email" placeholder="User Email" required />
              <small class="text-danger">{{ /*errors[0]*/ '' }}</small>

          </b-form-group>

          <b-form-group label="Phone:" label-for="input-phone">
              <!--
              <phone-mask-input id="phone" v-model="edited.phone" defaultCountry="us" inputClass="form-control" required />
              -->

              <b-form-input
                  id="phone"
                  v-model="edited.phone"
                  type="tel"
                  required
              />
              <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
          </b-form-group>

          <b-form-group label="Role:" label-for="input-name">
              <v-select required
                id="role_id"
                v-model="edited.roleObject"
                item-value="id"
                label="name"
                item-text="name"
                :options="adminRoles"
                :clearable="false"
              />
              <small class="text-danger">{{ /*errors[0]*/ '' }}</small>
          </b-form-group>

          <b-form-group v-show="edited.roleObject != null && edited.roleObject.name == 'Supervisor' ? true : false" label="Units:" label-for="input-name">
              <v-select
                id="unit_id"
                v-model="edited.units"
                item-value="id"
                label="name"
                item-text="name"
                :options="units"
                :clearable="false"
                :multiple="true"
              />
          </b-form-group>

          <b-form-checkbox v-model="edited.inactive" switch class="mb-1">
            Inactive User
          </b-form-checkbox>
        </b-form>

        <template #modal-footer>
          <b-button variant="outline-secondary" class="float-right" @click="$bvModal.hide('manage-modal')">
            Close
          </b-button>
          <b-button variant="primary" class="float-right" @click="edited.id > 0 ? editSubmit() : addSubmit()" :disabled="isEditLoading">
            <b-spinner v-if="isEditLoading" label="Spinning" small />
            <span v-else> Save </span>
          </b-button>
        </template>

      </b-modal>

    </template>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BModal,
  BForm,
  BSpinner,
  BButton,
  BTable,
  BFormCheckbox
} from 'bootstrap-vue'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next'
import { mapActions, mapGetters } from 'vuex'
import TablePagination from '@/views/Components/Elements/TablePagination.vue'
import { toastSuccess, toastFailure } from "@/libs/toastification";
import {sweetWarning, sweetError} from "@/libs/sweet-alerts";
import PhoneMaskInput from  "vue-phone-mask-input";
import ManageCustomer from "@/views/Components/ManageCustomer.vue";
import DatatableCellValue from '@/views/Components/Elements/DatatableCellValue.vue'
import {ref} from "vue";

export default {
  components: {
    TablePagination,
    ManageCustomer,
    DatatableCellValue,
    BTable,
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BSpinner,
    BButton,
    BForm,
    vSelect,
    BModal,
    BDropdown,
    BDropdownItem,
    PhoneMaskInput,
    BFormCheckbox
  },
  data() {
    return {
      clickDate: new Date(),
      isTableLoading: true,
      isEditLoading: false,
      isAddingLoading: false,
      searchTerm: '',
      adminRoles: [],
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Phone',
          field: 'phone',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Role',
          field: 'role',
        },
        {
          label: "Status",
          field: "inactive",
          sortable: true,
        },
        {
          label: "Action",
          field: "action",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        }
      ],
      pageLength: 25,
      edited: {
        id: null,
        name: null,
        email: null,
        phone: null,
        roleObject: null,
        units: null,
        inactive: null
      }
    }
  },
  computed: {
    ...mapGetters({
      users: 'auth/users',
      roles: 'roles/roles',
      units: 'units/units',
    }),
  },
  async mounted() {
    await this.loadUsers()
      .then(() => {
          this.isTableLoading = false;
          this.loadRoles().then(()=>{
            this.adminRoles = this.adminRolesOnly();
            this.loadUnits().catch(() => { toastFailure('Something went wrong while loading the units') })
          }).catch(() => { toastFailure('Something went wrong while loading the roles') });
        }
      ).catch(() => { toastFailure('Something went wrong while loading users.') })
  },
  methods: {
    ...mapActions({
      loadUsers: 'auth/loadUsers',
      createAdminUser: 'auth/createAdminUser',
      updateUser: 'auth/updateUser',
      deleteUser: 'auth/deleteUser',
      loadRoles: 'roles/loadRoles',
      loadUnits: 'units/loadUnits',
    }),
    showError(responseData=null, warning=false) {

      if( responseData != null && responseData.message != undefined && responseData.message != null ){

        let errorMSG = responseData.message + '</br>';
        if(responseData.errors){

          Object.keys(responseData.errors).map(function(errorKey){
            responseData.errors[errorKey].map(function(value, key){
              errorMSG += value + '</br>';
            });
          });
        }

        if( warning ){
          sweetWarning('Warning', errorMSG);
        }
        else{
          sweetError('Error', errorMSG);
        }
      }
      else{
        toastFailure("Something went wrong.");
      }
    },
    adminRolesOnly(){

      let adminRoles = [];
      this.roles.map(function(role){
        if( role.customer === false ){
          adminRoles.push(role);
        }
      });

      return adminRoles;
    },
    openEditModal(row) {
      this.edited.id = row.id;
      this.edited.name = row.name;
      this.edited.email = row.email;
      this.edited.phone = row.phone;
      this.edited.units = row.units;
      this.edited.roleObject = this.resolveRoleObject(row.role);
      this.edited.inactive = row.inactive == 1 ? true : false;
    },
    resolveRoleObject(role) {
      const roleName = typeof role === 'string' ? role : role?.name;

      return this.roles.find(x => x.name === roleName) || null;
    },
    openAddModal() {
      this.edited.id = 0;
      this.edited.name = '';
      this.edited.email = '';
      this.edited.phone = '';
      this.edited.units = [];
      this.edited.roleObject = this.roles.find(x => x.id === 1) || null;
    },
    async deleteItem(id) {
      if (await this.confirmationMessage('Are you sure you want to delete this user?')) {
        this.deletePackage(id)
              .then(() => {
                toastSuccess("User has been deleted.");
              })
              .catch(() => {
                toastFailure("Something went wrong while deleting the user");
              });
      }
    },
    async addSubmit() {

      let units = [];

      this.edited.units.map(function(unit){
        units.push(unit.id);
      });

      this.isAddingLoading = true;
      this.createAdminUser({
        name: this.edited.name,
        phone: this.edited.phone,
        email: this.edited.email,
        role_id: this.edited.roleObject.id,
        units: units
      })
      .then(() => {
        toastSuccess("New user added.");
      })
      .catch((error) => {
        this.showError(error.response.data);
      })
      .finally(() => {
        this.isAddingLoading = false;
        this.$bvModal.hide('manage-modal');
      });
    },
    async editSubmit() {

      this.isEditLoading = true;
      const formData = new FormData();

      formData.append('id', this.edited.id);
      formData.append('name', this.edited.name);
      formData.append('email', this.edited.email);
      formData.append('phone', this.edited.phone);
      formData.append('inactive', (this.edited.inactive === true ? 1 : 0));
      formData.append('role_id', this.edited.roleObject.id);

      this.edited.units.map(function(unit){
        formData.append('units[]', unit.id);
      });

      if( this.edited.units !== null && this.edited.units.length > 0 && this.edited.inactive === true ){
        let smsError = {
          message:'This user is a supervisor of a unit. Please change the supervisor of the unit before making user inactive'
        };
        this.showError(smsError, 1);
        this.isEditLoading = false;
        return false;
      }

      formData.append('_method', 'POST');
      this.updateUser(formData)
      .then(() => {
        toastSuccess("Your changes have been updated.");
      })
      .catch((error) => {
        this.showError(error.response.data);
      })
      .finally(() => {
        this.isEditLoading = false;
        this.$bvModal.hide('manage-modal');
      });
    },
  },
}
</script>
